import hasAccess from '@/mixins/hasAccess';
import { call, get, sync } from 'vuex-pathify';

let SSE = undefined;

export default {
  mixins: [hasAccess],
  computed: {
    generatingGeoportalMapsIds: sync('geoportals/generatingGeoportalMapsIds'),
    token: get('authentication/token'),
    sseEventsHandlers() {
      return {
        ...(this.hasAccess({ modules: ['GEOPORTAL_MODULE'] }) && {
          geoportal: async ({ data }) => {
            const statusesDict = {
              error: ['failed_jsonl', 'failed_geojson', 'failed_fgb', 'failed_gpkg', 'failed_mbtiles', 'failed'],
              success: ['done'],
            };
            const status = Object.entries(statusesDict).find(([_, values]) => values.includes(data.status))?.[0];
            if (status === 'success') {
              this.generatingGeoportalMapsIds = this.generatingGeoportalMapsIds.filter(id => id !== data.project_id);
              await this.getGeoportals();
            } else if (status === 'error') {
              //
            } else {
              this.generatingGeoportalMapsIds = Array.from(
                new Set([...this.generatingGeoportalMapsIds, data.project_id])
              );
            }
          },
        }),
      };
    },
  },
  methods: {
    getGeoportals: call('geoportals/getGeoportals'),
    initSse() {
      SSE?.close();
      if (!this.token) return;
      this.$nextTick(() => {
        SSE = new EventSource(`${import.meta.env.VUE_APP_API_URL}/v2/sse?token=${this.token}`);
        SSE.onmessage = e => {
          const parsedData = JSON.parse(e.data);
          this.sseEventsHandlers[parsedData.name]?.(parsedData, e);
        };
      });
    },
  },
  watch: {
    token: {
      handler() {
        this.initSse();
      },
      immediate: true,
    },
  },
};
